export const initialState = {
    score: 0,
    brand: {
        email: '',
        name: '',
        url: '',
        salesChannel: [],
        category: '',
        competitors: [],
        productDescription: '',
    },
    targetGroup: {
        age: ['12 - 15', '16 - 19'],
        gender: [],
        income: [],
        geos: [],
        additionalDetails: '',
    },
    campaignDetails: {
        budget: 10000,
        duration: {
            value: 10,
            unit: 'days',
            flexible: false,
        },
        campaignRequirement: '',
        businessObjective: '',
        startDate: new Date(),
        marketingObjective: '',
        expectedFrequency: {
            marketFactors: {
                brandStage: 3,
                marketShare: 3,
                purchaseCycle: 3,
                sov: 3,
            },
            adFactors: {
                messageComplexity: 3,
                messageUniqueness: 3,
                campaignStage: 3,
            },
            mediaFactors: {
                seasonality: 3,
                duration: 3,
                schedulingType: 3,
                mediaChannels: 3,
            },
            objective: {
                markObjective: 3,
            },
        },
        estimatedFrequency: 3,
        expectedReach: 0,
        availableAdType: [],
    },
    mediaPreference: {
        plannerRecommendation: false,
        otherMediaPreferences: '',
        preference: {},
    },
    mediaSpecificDetails: [],
};
